import React from 'react'
import { makeStyles } from '@material-ui/core/styles';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import './StyledTableBody.css'

const useStyles = makeStyles({
    StyledBody: {
    },
    StyledRow: {
        cursor:"pointer"
    },
    StyledCell:{
        color:"black",
        fontFamily:"Microsoft JhengHei",
        fontSize:12
    }
  });
  

export default function StyledTableBody(props) {
    const classes = useStyles();
    let index = 1

    return (
        <TableBody className={classes.StyledBody}>
            {
                
                props.listData.map(row=>(
                    <TableRow hover className={classes.StyledRow} key={row.Event_SysID} onClick={()=>props.handleEventListClicked(row.Event_SysID)} onContextMenu={(e)=>{
                        e.preventDefault()
                        let msg={
                            ID : row.Event_SysID,
                            pos:{
                                x:e.clientX,
                                y:e.clientY
                            }
                        }
                        props.openContextManu(msg)
                    }}>
                        <TableCell className={classes.StyledCell} align="left">{index++}</TableCell>
                        <TableCell className={classes.StyledCell} align="left">{row.Event_SysID}</TableCell>
                        <TableCell className={classes.StyledCell} align="left">{row.Event_Title}</TableCell>
                        <TableCell className={classes.StyledCell} align="left">{row.Event_CreatedDate}</TableCell>
                        <TableCell className={classes.StyledCell} align="left">{row.User_Name}</TableCell>
                        <TableCell className={classes.StyledCell} align="left">{row.Event_SubTitle}</TableCell>
                        <TableCell className={classes.StyledCell} align="left">{row.Event_Story}</TableCell>
                        <TableCell className={classes.StyledCell} align="left">{row.Event_StartDate}</TableCell>
                        <TableCell className={classes.StyledCell} align="left">{row.Event_EndDate}</TableCell>
                    </TableRow>
                ))
            }
        </TableBody>
    )
}